export enum PensionPlanTypes {
	ClergyDb = 'clergydb',
	LayDb = 'laydb',
	LayDc = 'laydc',
	Rsvp = 'rsvp',
	OePlans = 'oe_plan',
}

export interface PlanHistoryDto {
    id: number;
    date_of_change: string;
    time_of_change: string;
    adoption_date: string;
    amendment_date: string;
    employer_base: string;
    employer_match: string;
    minimum_scheduled_hours: string;
    allow_multiple_contribution_schedules: string;
    contribution_type: string;
    eligible_population: string;
    end_date: string;
    qcco_status_history: [{
        id: string;
        supported_by_church: string;
        offers_services_to_public: string;
        receives_gov_support: string;
        status: string;
        start_date: string;
    }];
}

export interface PensionPlanDetail {
    id: number;
    name: string;
    effective_date: string;
    latest_amendment_date: string;
    employer_base: string;
    employer_matc: string;
    minimum_scheduled_hours: string;
    allow_multiple_contribution_schedules: string;
    status: string;
    vesting_schedule: string;
    eligible_population: string;
    history: PlanHistoryDto[];
}
